<template>
  <div class="content-page">
    <div class="tab-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/goods' }">商品管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{
          goodsForm.goodsId ? "编辑商品" : "新建商品"
        }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="tab-content">
      <el-form
        :model="goodsForm"
        :rules="rules"
        ref="goodsForm"
        label-width="68px"
        class="demo-goodsForm"
        :hide-required-asterisk="true"
      >
        <el-form-item label="商品名称" prop="goodsName">
          <el-input
            v-model="goodsForm.goodsName"
            placeholder="请填写商品名称"
            maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="商品分类"
          prop="goodsCategoryId"
          v-if="classifyOptionsNoGroup.length"
        >
          <el-cascader
            v-model="goodsCategoryCascaderValue"
            :options="categoryCascaderOptions"
            :props="categoryCascaderProps"
            clearable
            filterable
            placeholder="请选择"
            @change="handleGoodsCategoryChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="商品主图" prop="goodsImage">
          <div>
            <el-upload
              :disabled="uploadDisabled"
              action="/ImageServer/YmUpload_image"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="
                (e) => {
                  handleRemove(e, 'goodsImage');
                }
              "
              :http-request="
                (e) => {
                  handleSuccess(e, 'goodsImage');
                }
              "
              :before-upload="beforeImgUpload"
              :on-exceed="limitTip"
              :file-list="fileList"
              :limit="1"
            >
              <div
                style="width: 148px; height: 148px; position: absolute"
                @click="show_uploadDialog(1, 'goodsImage')"
              ></div>
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
          </div>
        </el-form-item>
        <el-form-item label="轮播图" prop="goodsImages">
          <div>
            <el-upload
              :disabled="uploadDisabled"
              action="/ImageServer/YmUpload_image"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="
                (e) => {
                  handleRemove(e, 'goodsImages');
                }
              "
              :http-request="
                (e) => {
                  handleSuccess(e, 'goodsImages');
                }
              "
              :before-upload="beforeImgUpload"
              :file-list="goodsImages"
              :before-remove="beforeRemove"
            >
              <div
                style="width: 148px; height: 148px; position: absolute"
                @click="show_uploadDialog(999, 'goodsImages')"
              ></div>
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
          </div>
        </el-form-item>
        <el-form-item label="商品描述" maxlength="100">
          <el-input
            type="textarea"
            placeholder="请填写商品描述"
            v-model="goodsForm.goodsDescription"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品多图" prop="goodsDescriptionImages">
          <div>
            <el-upload
              :disabled="uploadDisabled"
              action="/ImageServer/YmUpload_image"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="
                (e) => {
                  handleRemove(e, 'goodsDescriptionImages');
                }
              "
              :http-request="
                (e) => {
                  handleSuccess(e, 'goodsDescriptionImages');
                }
              "
              :before-upload="beforeImgUpload"
              :file-list="goodsDescriptionImages1"
              :before-remove="beforeRemove"
            >
              <div
                style="width: 148px; height: 148px; position: absolute"
                @click="show_uploadDialog(999, 'goodsDescriptionImages')"
              ></div>
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
          </div>
        </el-form-item>
        <!-- <el-form-item label="快递费用" maxlength="100">
          <el-input
            placeholder="请填写快递费用"
            v-model="goodsForm.shipPrice"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="快递模板" maxlength="100" v-if="shopInfo.edcShopType != 5">
          <el-select v-model="goodsForm.deliverySettingId" placeholder="请选择">
            <el-option
              v-for="item in deliverySettingList"
              :key="item.id"
              :label="item.settingName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="商品条码" maxlength="100">
          <el-input
            placeholder="请填写商品条形码"
            v-model="goodsForm.goodsBarCode"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="商品单位" prop="unit">
          <el-input v-model="goodsForm.unit" placeholder="如：份、斤"></el-input>
        </el-form-item>
        <el-form-item label="月销基数" prop="baseSales">
          <el-input
            placeholder="填写月销基数"
            v-model="goodsForm.baseSales"
            size="small"
            clearable
            type="number"
            min="0"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品分组" prop="groupIds" v-if="groupOptions.length">
          <el-checkbox-group v-model="goodsForm.groupIds" size="small">
            <el-checkbox
              v-for="item in groupOptions"
              :key="item.goodsCategoryId"
              :label="`${item.goodsCategoryId}`"
              :disabled="
                goodsForm.groupIds.length &&
                !~goodsForm.groupIds.indexOf(`${item.goodsCategoryId}`)
              "
              >{{ item.categoryName }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <!-- <el-form-item label="必选菜品" prop="isRequired">
          <el-radio-group v-model="goodsForm.isRequired">
            <el-radio :label="0">非必选</el-radio>
            <el-radio :label="1">必选（1人1份）</el-radio>
            <el-radio :label="2">必选（1桌一份）</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="活动商品" prop="isPromote">
          <el-radio-group v-model="goodsForm.isPromote">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="推荐商品"
          prop="isRecommend"
          v-if="shopInfo.edcShopType != 8"
        >
          <el-radio-group v-model="goodsForm.isRecommend">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否参与打折" prop="isCanDiscount">
          <el-radio-group v-model="goodsForm.isCanDiscount">
            <el-radio :label="0">参与</el-radio>
            <el-radio :label="1">不参与</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="快速退菜" prop="refundNoAuth">
          <el-radio-group v-model="goodsForm.refundNoAuth">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <!-- <el-form-item label="支持超卖" prop="isOversold">
                    <el-radio-group v-model="goodsForm.isOversold">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item> -->
        <!-- <el-form-item label="商品标签" prop="goodsLabel">
          <el-checkbox-group v-model="goodsForm.goodsLabel" size="small">
            <el-checkbox label="1">招牌</el-checkbox>
            <el-checkbox label="2">新菜</el-checkbox>
            <el-checkbox label="3">辣</el-checkbox>
          </el-checkbox-group>
        </el-form-item> -->
        <el-form-item label="商品规格" prop="products">
          <div class="custom-form">
            <div class="form-header">
              <div class="fixed-width" v-if="shopInfo.edcShopType != 5">商品规格</div>
              <div class="fixed-width">价格</div>
              <!-- <div class="fixed-width">
                餐盒费<span class="tips">(餐盒费参与会员打折)</span>
              </div> -->
              <div class="fixed-width">会员价</div>
              <div class="fixed-width">条码</div>
              <div class="indefinite-width">库存</div>
            </div>
            <div class="form-content">
              <div class="item" v-for="(item, index) in goodsForm.products" :key="index">
                <div class="fixed-width" v-if="shopInfo.edcShopType != 5">
                  <el-input
                    placeholder="如：大份"
                    v-model="item.valueContent"
                    size="small"
                    clearable
                  ></el-input>
                </div>
                <div class="fixed-width">
                  <el-input
                    placeholder="填写价格"
                    v-model="item.retailPrice"
                    size="small"
                    @input.native="numberInputChange"
                    @blur="numberInputBlur"
                    clearable
                    type="number"
                  ></el-input>
                </div>
                <!-- <div class="fixed-width">
                  <el-input
                    placeholder="填写餐盒费"
                    v-model="item.foodBoxPrice"
                    @input.native="numberInputChange"
                    @blur="numberInputBlur"
                    size="small"
                    clearable
                    type="number"
                  ></el-input>
                </div> -->
                <div class="fixed-width">
                  <el-input
                    placeholder="填写会员价格"
                    v-model="item.memberPrice"
                    size="small"
                    @input.native="numberInputChange"
                    @blur="numberInputBlur"
                    clearable
                    type="number"
                  ></el-input>
                </div>
                <div class="fixed-width">
                  <el-input
                    placeholder="请填写条形码"
                    v-model="item.barCode"
                    size="small"
                    clearable
                  ></el-input>
                </div>
                <div class="indefinite-width">
                  <el-radio-group v-model="item.stockType">
                    <!-- <el-radio label="infinite">无限库存</el-radio> -->
                    <el-radio label="custom">自定义库存</el-radio>
                  </el-radio-group>
                  <el-input
                    v-show="item.stockType == 'custom'"
                    placeholder="输入库存"
                    v-model="item.stockCount"
                    size="small"
                    clearable
                    type="number"
                  ></el-input>
                  <el-button
                    type="text"
                    v-if="goodsForm.products.length > 1"
                    @click="delGoodsSpec(index)"
                    >删除</el-button
                  >
                </div>
              </div>
            </div>
            <el-button
              v-if="goodsForm.isRequired == 0 && shopInfo.edcShopType != 5"
              type="primary"
              size="small"
              @click="addGoodsSpec"
              >添加规格</el-button
            >
          </div>
        </el-form-item>
        <el-form-item label="商品属性" prop="freeSpecs" v-if="goodsForm.isRequired == 0">
          <div class="custom-form">
            <div class="form-header">
              <div class="fixed-width">属性名称</div>
              <div class="indefinite-width">属性值</div>
            </div>
            <div class="form-content">
              <div class="item" v-for="(item, index) in goodsForm.freeSpecs" :key="index">
                <div class="fixed-width">
                  <el-input
                    placeholder="如：大份"
                    v-model="item.name"
                    size="small"
                    clearable
                  ></el-input>
                </div>
                <div class="indefinite-width">
                  <el-tag
                    :key="tagindex"
                    v-for="(tag, tagindex) in item.value"
                    closable
                    :disable-transitions="false"
                    @close="handleClose(tag, index)"
                    >{{ tag }}</el-tag
                  >
                  <el-input
                    class="input-new-tag"
                    v-if="item.attrValueInputVisible"
                    v-model="item.attrValueInputValue"
                    :ref="`saveTagInput${index}`"
                    size="small"
                    @keyup.enter.native="handleAttrValueInputConfirm(index)"
                    @blur="handleAttrValueInputConfirm(index)"
                  ></el-input>
                  <el-button
                    v-else
                    class="button-new-tag"
                    size="small"
                    @click="showAttrValueInput(index)"
                    >+ 添加</el-button
                  >
                  <el-button
                    type="text"
                    v-if="goodsForm.freeSpecs.length > 1"
                    @click="delGoodsAttr(index)"
                    >删除</el-button
                  >
                </div>
              </div>
            </div>
            <el-button type="primary" size="small" @click="addGoodsAttr"
              >添加属性</el-button
            >
          </div>
        </el-form-item>
        <el-form-item label="商品链接" maxlength="100" v-if="goodsForm.goodsId">
          <el-input
            disabled
            readOnly
            :value="`pages/goodsDetails/goodsDetails?goodsId=${goodsForm.goodsId}`"
          />
          <input
            class="goodsUrl"
            :value="`pages/goodsDetails/goodsDetails?goodsId=${goodsForm.goodsId}`"
          />
          <el-button type="primary" @click="copyGoodsUrl">复制</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('goodsForm')"
            :loading="isSubmit"
            >{{ goodsForm.goodsId ? "提交编辑" : "立即创建" }}</el-button
          >
          <el-button @click="resetForm('goodsForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <uploadImgComponent
      :isshow_uploadDialog="isshow_uploadDialog"
      @onClose="close_uploadDialog"
      @getChoose_ImgUrl="getChoose_ImgUrl"
      ref="childRef"
      :ImgLimits="ImgLimits"
      :uploadName="uploadName"
    ></uploadImgComponent>
  </div>
</template>

<script>
import {
  uploadImg,
  getEdcShopGoodsCategorys,
  updateGoods,
  getGoodsAllInfo,
  getDeliverySettingListFree,
} from "@/api";
import { formatGoodsCategoryListForUI } from "@/utils/goodsCategory";
import {
  getCategoryIdFromCascader,
  loadSecondaryCategoryForCascader,
  toCategoryCascaderOptions,
} from "@/utils/secondaryCategory";
import uploadImgComponent from "@/components/uploadImg";
import { mapState } from "vuex";
export default {
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      fileList: [],
      goodsImages: [],
      goodsDescriptionImages1: [],
      goodsForm: {
        goodsId: "",
        goodsName: "",
        goodsCategoryId: "",
        goodsDescription: "",
        goodsBarCode: "",
        goodsImage: "",
        goodsImages: "",
        goodsDescriptionImages: "",
        shipPrice: 0,
        deliverySettingId: 0,
        unit: "",
        baseSales: 0,
        isRequired: 0,
        isPromote: 0,
        refundNoAuth: 0,
        isOversold: 0,
        isRecommend: 0,
        tags: "",
        goodsLabel: [],
        groupIds: [],
        products: [
          {
            productId: "",
            retailPrice: "0.00",
            foodBoxPrice: "0.00",
            memberPrice: "0.00",
            barCode: "",
            stockType: "custom",
            stockCount: 1000,
            valueContent: "",
          },
        ],
        freeSpecs: [
          {
            name: "",
            value: [],
            specValueList: [],
            attrValueInputVisible: false,
            attrValueInputValue: "",
          },
        ],
      },
      rules: {
        goodsImage: [
          {
            required: true,
            message: "请至少上传一张图片",
            trigger: "blur",
          },
        ],
        goodsImages: [
          {
            required: true,
            message: "请至少上传一张图片",
            trigger: "blur",
          },
        ],
        goodsDescriptionImages: [
          {
            required: true,
            message: "请至少上传一张图片",
            trigger: "blur",
          },
        ],
        shipPrice: [
          {
            required: true,
            message: "请填写快递费用",
            trigger: "blur",
          },
        ],
        deliverySettingId: [
          {
            required: true,
            message: "请选择快递模板",
            trigger: "blur",
          },
        ],
        goodsName: [
          {
            required: true,
            message: "请填写商品名称",
            trigger: "blur",
          },
        ],
        // goodsDescription: [
        //     {
        //         required: true,
        //         message: "请填写商品描述",
        //         trigger: "blur"
        //     }
        // ],
        unit: [
          {
            required: true,
            message: "请填写商品单位",
            trigger: "blur",
          },
        ],
      },
      classifyOptions: [],
      classifyOptionsNoGroup: [],
      categoryCascaderOptions: [],
      goodsCategoryCascaderValue: [],
      groupOptions: [],
      isAddGoodsSpec: false,
      isSubmit: false,
      isshow_uploadDialog: false,
      uploadDisabled: false,
      deliverySettingList: [],
      ImgLimits: 0,
      uploadName: "",
    };
  },
  components: {
    uploadImgComponent,
  },
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
    }),
    categoryCascaderProps() {
      return {
        checkStrictly: true,
        emitPath: true,
        lazy: true,
        lazyLoad: this.loadCategoryCascader,
      };
    },
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    getDeliverySettingListFree() {
      getDeliverySettingListFree().then((res) => {
        if (res.code == 1) {
          this.deliverySettingList = res.data;
        }
      });
    },
    show_uploadDialog(val, name) {
      this.ImgLimits = val;
      this.uploadName = name;
      this.uploadDisabled = true;
      this.$refs.childRef.rSelect = [];
      this.isshow_uploadDialog = true;
    },
    getChoose_ImgUrl(arr, name) {
      console.log(arr, name);
      this.isshow_uploadDialog = false;
      this.uploadDisabled = false;
      if (arr.length > 0) {
        arr.forEach((item) => {
          if (name == "goodsImages") {
            // console.log(this.goodsForm.goodsImages, "this.goodsForm.goodsImages");
            if (this.goodsForm.goodsImages.length) {
              this.goodsForm.goodsImages += `,${item.image}`;
            } else {
              this.goodsForm.goodsImages = item.image;
            }
            // console.log(this.goodsImages, "this.goodsImages")
            this.goodsImages.push({ name: "", url: item.image });
            // let goodsImages1 = this.goodsForm.goodsImages.split(",");
            // this.goodsImages = []
            // goodsImages1.forEach(item => {
            //   this.goodsImages.push({ name: "", url: item });
            // })
            return;
          }
          if (name == "goodsDescriptionImages") {
            if (this.goodsForm.goodsDescriptionImages.length) {
              this.goodsForm.goodsDescriptionImages += `,${item.image}`;
            } else {
              this.goodsForm.goodsDescriptionImages = item.image;
            }
            // let goodsImages2 = this.goodsForm.goodsDescriptionImages.split(",");
            // this.goodsDescriptionImages1 = []
            // goodsImages2.forEach(item => {
            //   this.goodsDescriptionImages1.push({ name: "", url: item });
            // })
            this.goodsDescriptionImages1.push({ name: "", url: item.image });
            return;
          }
          this.goodsForm.goodsImage = item.image;
          this.fileList = [{ url: this.goodsForm.goodsImage }];
          this.$refs["goodsForm"].validate();
        });
      }
    },
    close_uploadDialog() {
      this.isshow_uploadDialog = false;
      this.uploadDisabled = false;
    },
    async getPageData() {
      await getEdcShopGoodsCategorys({
        row: 1000,
      }).then((res) => {
        if (res.code == 1) {
          res.data = formatGoodsCategoryListForUI(res.data);
          this.classifyOptions = res.data;
          res.data.forEach((val) => {
            if (val.categoryType == 2) {
              this.groupOptions.push(val);
            } else {
              this.classifyOptionsNoGroup.push(val);
            }
          });
          this.goodsForm.goodsCategoryId = this.classifyOptionsNoGroup[0].goodsCategoryId;
          this.categoryCascaderOptions = toCategoryCascaderOptions(
            this.classifyOptionsNoGroup,
            {
              includeAll: false,
            }
          );
          this.goodsCategoryCascaderValue = [this.goodsForm.goodsCategoryId];
          this.menuSel = this.classifyOptionsNoGroup[0].goodsCategoryId;
        }
      });
      if (this.$route.query.goodsId) {
        this.goodsForm.goodsId = this.$route.query.goodsId;
        await getGoodsAllInfo({
          goodsId: this.goodsForm.goodsId,
        }).then((res) => {
          if (res.code == 1) {
            let goodsForm = {
              goodsId: res.data.good.goodsId,
              goodsName: res.data.good.goodsName,
              goodsCategoryId: res.data.good.goodsCategoryId,
              goodsDescription: res.data.good.goodsDescription,
              goodsBarCode: res.data.good.goodsBarCode,
              goodsImage: res.data.good.goodsImage,
              goodsImages: res.data.good.goodsImages || "",
              goodsDescriptionImages: res.data.good.goodsDescriptionImages || "",
              shipPrice: res.data.good.shipPrice,
              deliverySettingId: res.data.good.deliverySettingId || 0,
              unit: res.data.good.unit,
              baseSales: res.data.good.baseSales || 0,
              isRequired: res.data.good.isRequired,
              isPromote: res.data.good.isPromote,
              isRecommend: res.data.good.isRecommend || 0,
              isCanDiscount: res.data.good.isCanDiscount || 0,
              refundNoAuth: res.data.good.refundNoAuth || 0,
              tags: res.data.good.tags,
              goodsLabel: res.data.good.tags ? res.data.good.tags.split(",") : [],
              groupIds: res.data.good.groupIds ? [res.data.good.groupIds] : [],
              products: [],
              freeSpecs: [],
            };
            if (res.data.freeSpecs && res.data.freeSpecs.length) {
              res.data.freeSpecs.forEach((val) => {
                let data = {
                  name: val.name,
                  value: [],
                  specValueList: val.specValueList,
                  attrValueInputVisible: false,
                  attrValueInputValue: "",
                };
                if (val.specValueList.length) {
                  val.specValueList.forEach((subval) => {
                    data.value.push(subval.value);
                  });
                }
                goodsForm.freeSpecs.push(data);
              });
            } else {
              goodsForm.freeSpecs = [
                {
                  name: "",
                  value: [],
                  specValueList: [],
                  attrValueInputVisible: false,
                  attrValueInputValue: "",
                },
              ];
            }
            if (res.data.products && res.data.products.length) {
              this.isAddGoodsSpec = true;
              res.data.products.forEach((val) => {
                let data = {
                  goodsId: val.goodsId,
                  productId: val.productId,
                  retailPrice: val.retailPrice,
                  foodBoxPrice: val.foodBoxPrice,
                  memberPrice: val.memberPrice,
                  barCode: val.barCode,
                  stockType: "custom",
                  stockCount: val.stockCount,
                  valueContent: val.valueContent,
                };
                goodsForm.products.push(data);
              });
            } else {
              goodsForm.products = [
                {
                  goodsId: res.data.good.goodsId,
                  productId: "",
                  retailPrice: res.data.good.retailPrice,
                  foodBoxPrice: res.data.good.foodBoxPrice,
                  memberPrice: res.data.good.memberPrice,
                  barCode: res.data.good.barCode,
                  stockType: "custom",
                  stockCount: res.data.good.totalStockCount,
                  valueContent: "",
                },
              ];
            }
            let goodsImages = goodsForm.goodsImages
              ? goodsForm.goodsImages.split(",")
              : [];
            if (goodsImages.length && goodsImages[0].length) {
              goodsImages.forEach((val) => {
                this.goodsImages.push({
                  name: val,
                  url: val,
                });
              });
            }
            let goodsDescriptionImages = goodsForm.goodsDescriptionImages
              ? goodsForm.goodsDescriptionImages.split(",")
              : [];
            if (goodsDescriptionImages.length && goodsDescriptionImages[0].length) {
              goodsDescriptionImages.forEach((val) => {
                this.goodsDescriptionImages1.push({
                  name: val,
                  url: val,
                });
              });
            }
            if (res.data.good.goodsImage) {
              this.fileList = [{ url: res.data.good.goodsImage }];
            } else {
              this.fileList = [];
            }
            this.goodsForm = goodsForm;
            this.goodsCategoryCascaderValue = this.goodsForm.goodsCategoryId
              ? [this.goodsForm.goodsCategoryId]
              : [];
          }
        });
      }
      this.getDeliverySettingListFree();
    },
    handleRemove(file, name) {
      console.log(file, name);
      if (name == "goodsImages") {
        let goodsImages = this.goodsForm.goodsImages.split(",");
        let goodsImages1 = this.goodsForm.goodsImages.split(",");
        // console.log(goodsImages.length, goodsImages, "删除前的goodsImages");
        goodsImages.splice(goodsImages.indexOf(file.url), 1);
        // console.log(goodsImages, "删除后的goodsImages");
        this.goodsForm.goodsImages = "";
        this.goodsForm.goodsImages = goodsImages.join(",");
        // console.log(goodsImages, "goodsImages")
        // console.log(this.goodsForm.goodsImages, "this.goodsForm.goodsImages")
        // console.log(this.goodsImages, "删除前的this.goodsImages")
        this.goodsImages.splice(goodsImages1.indexOf(file.url), 1);
        // console.log(this.goodsImages, "删除后的this.goodsImages")
      } else if (name == "goodsDescriptionImages") {
        // console.log(11111);
        let goodsDescriptionImages = this.goodsForm.goodsDescriptionImages.split(",");
        let goodsDescriptionImages1 = this.goodsForm.goodsDescriptionImages.split(",");
        // console.log(goodsDescriptionImages.length, "goodsDescriptionImages.length");
        goodsDescriptionImages.splice(goodsDescriptionImages.indexOf(file.name), 1);
        // console.log(file.name, "file.name");
        this.goodsForm.goodsDescriptionImages = goodsDescriptionImages.join(",");
        this.goodsDescriptionImages1.splice(goodsDescriptionImages1.indexOf(file.url), 1);
      } else {
        this.goodsForm[name] = "";
      }
    },
    limitTip(files, fileList) {
      console.log(file, "file", fileList, "fileList");
      this.$notify({
        title: "警告",
        message: "只能上传一张图片，请删除图片后再上传",
        type: "warning",
        duration: 6000,
      });
    },
    beforeRemove(file, fileList) {},
    beforeImgUpload(file) {
      const isLt3M = file.size / 1024 / 1024 < 3;
      if (!isLt3M) {
        this.$notify.error("上传图片大小不能超过 3MB!");
      }
      return isLt3M;
    },
    handleSuccess(item, name) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", item.file);
      imgUploadForm.append("fileContentType", item.file.type);
      imgUploadForm.append("fileFileName", item.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      uploadImg(imgUploadForm).then((res) => {
        console.log(res);
        if (res.code == 1) {
          if (name == "goodsImages" || name == "goodsDescriptionImages") {
            if (this.goodsForm[name].length) {
              this.goodsForm[name] += `,${res.data.url}`;
            } else {
              this.goodsForm[name] = res.data.url;
            }
            return;
          }
          this.goodsForm[name] = res.data.url;
        }
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    loadCategoryCascader(node, resolve) {
      loadSecondaryCategoryForCascader(node, resolve, 1000);
    },
    handleGoodsCategoryChange(value) {
      this.goodsForm.goodsCategoryId = getCategoryIdFromCascader(value);
    },
    submitForm(formName) {
      console.log(this.goodsForm, "提交编辑");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.goodsForm));
          params.tags = params.goodsLabel.join(",");
          params.freeSpecs = [];
          params.groupIds = params.groupIds[0];
          let isNoneValueFreeSpecs = false;
          this.goodsForm.freeSpecs.forEach((val, index) => {
            if (val.name && val.value.length) {
              params.freeSpecs[index] = val;
              params.freeSpecs[index].specValueList = [];
              val.value.forEach((subval) => {
                params.freeSpecs[index].specValueList.push({
                  value: subval,
                });
              });
            } else {
              if (val.name) {
                isNoneValueFreeSpecs = true;
              }
              params.freeSpecs.splice(index, 1);
            }
          });
          if (isNoneValueFreeSpecs) {
            this.$notify({
              title: "提示",
              message: "商品属性值不能为空",
              type: "error",
              duration: 2000,
            });
            return;
          }
          params.freeSpecs = JSON.stringify(params.freeSpecs);
          params.totalStockCount = 0;
          params.products = [];
          this.isSubmit = true;
          this.goodsForm.products.forEach((val, index) => {
            // if (val.valueContent) {
            params.products.push({
              goodsId: this.goodsForm.goodsId,
              productId: val.productId ? val.productId : "",
              retailPrice: val.retailPrice,
              foodBoxPrice: val.foodBoxPrice || 0,
              memberPrice: val.memberPrice,
              barCode: val.barCode,
              costPrice: 0,
              stockType: "custom",
              stockCount: val.stockCount,
              valueContent: val.valueContent,
            });
            params.totalStockCount += Number(val.stockCount);
            // } else {
            //   if (this.goodsForm.products.length > 1) {
            //     params.products.splice(index, 1);
            //   } else {
            //     params.totalStockCount = val.stockCount;
            //   }
            // }
          });
          params.retailPrice = this.goodsForm.products[0].retailPrice;
          params.foodBoxPrice = this.goodsForm.products[0].foodBoxPrice || 0;
          params.memberPrice = this.goodsForm.products[0].memberPrice;
          params.costPrice = this.goodsForm.products[0].costPrice;
          params.products = JSON.stringify(params.products);
          if (this.shopInfo.edcShopType == 5) {
            params.products = [];
            params.unitType = 2;
          }
          updateGoods(params).then((res) => {
            if (res.code == 1) {
              this.$notify({
                title: "提示",
                message: this.goodsForm.goodsId ? "编辑成功" : "创建成功",
                type: "success",
                duration: 3000,
              });
              // this.$router.go(-1);
              this.$router.push({
                path: "/goods",
                query: {
                  pageNo: this.$route.query.pageNo,
                  menuSel: this.$route.query.menuSel,
                  parentMenuSel: this.$route.query.parentMenuSel,
                },
              });
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "error",
                duration: 2000,
              });
            }
            this.isSubmit = false;
          });
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    resetForm(formName) {
      this.fileList = [];
      this.goodsForm = {
        goodsId: this.goodsForm.goodsId ? this.goodsForm.goodsId : "",
        goodsName: "",
        goodsCategoryId: this.goodsForm.goodsCategoryId,
        goodsDescription: "",
        goodsBarCode: "",
        goodsImage: "",
        goodsImages: "",
        shipPrice: 0,
        deliverySettingId: 0,
        unit: "",
        baseSales: 0,
        isRequired: 0,
        isPromote: 0,
        isCanDiscount: 0,
        refundNoAuth: 0,
        tags: "",
        goodsLabel: [],
        products: [
          {
            productId: "",
            retailPrice: "0.00",
            foodBoxPrice: "0.00",
            memberPrice: "0.00",
            barCode: "",
            stockType: "custom",
            stockCount: 1000,
            valueContent: "",
          },
        ],
        freeSpecs: [
          {
            name: "",
            value: [],
            specValueList: [],
            attrValueInputVisible: false,
            attrValueInputValue: "",
          },
        ],
      };
      this.$refs.goodsForm.resetFields();
    },
    addGoodsSpec() {
      this.goodsForm.products.push({
        productId: "",
        retailPrice: "0.00",
        foodBoxPrice: "0.00",
        memberPrice: "0.00",
        barCode: "",
        stockType: "custom",
        stockCount: 1000,
        valueContent: "",
      });
    },
    delGoodsSpec(index) {
      this.goodsForm.products.splice(index, 1);
    },
    addGoodsAttr() {
      this.goodsForm.freeSpecs.push({
        name: "",
        value: [],
        specValueList: [],
        attrValueInputVisible: false,
        attrValueInputValue: "",
      });
    },
    delGoodsAttr(index) {
      this.goodsForm.freeSpecs.splice(index, 1);
    },
    handleClose(tag, index) {
      this.goodsForm.freeSpecs[index].value.splice(
        this.goodsForm.freeSpecs[index].value.indexOf(tag),
        1
      );
    },

    showAttrValueInput(index) {
      this.goodsForm.freeSpecs[index].attrValueInputVisible = true;
      this.$nextTick((_) => {
        this.$refs[`saveTagInput${index}`][0].focus();
      });
    },
    handleAttrValueInputConfirm(index) {
      let attrValueInputValue = this.goodsForm.freeSpecs[index].attrValueInputValue;
      if (attrValueInputValue) {
        this.goodsForm.freeSpecs[index].value.push(attrValueInputValue);
      }
      this.goodsForm.freeSpecs[index].attrValueInputVisible = false;
      this.goodsForm.freeSpecs[index].attrValueInputValue = "";
    },
    numberInputChange(e) {
      if (~e.target.value.indexOf(".") && e.target.value.split(".")[1].length >= 2) {
        e.target.value = Number(e.target.value).toFixed(2);
      }
    },
    numberInputBlur(e) {
      if (e.target.value.indexOf(".") == -1) {
        e.target.value = Number(e.target.value).toFixed(1);
      }
    },
    copyGoodsUrl() {
      var copyText = document.querySelector(`.goodsUrl`);
      copyText.select();
      document.execCommand("copy");
      this.$notify({
        title: "提示",
        message: "复制成功",
        type: "success",
        duration: 1000,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .tab-header {
    padding: 12px 20px;
  }
  .tab-content {
    padding: 40px 48px;
  }
  .custom-form {
    width: 1080px;
    background: #f8f8f8;
    font-size: 14px;
    color: #606266;
    padding: 12px 0 20px 20px;
    box-sizing: border-box;
    .form-header,
    .form-content > .item {
      display: flex;
      & > div {
        margin-right: 20px;
      }
      .fixed-width {
        width: 124px;
        .tips {
          font-size: 12px;
          color: red;
          white-space: nowrap;
        }
        .el-input {
          width: 140px;
        }
      }
      .indefinite-width {
        .el-input {
          width: 100px;
          margin: 0 16px 0 10px;
        }
        .el-tag {
          margin-right: 10px;
        }
        .el-button--text {
          margin-left: 10px;
        }
      }
    }
    & > .el-button {
      margin-top: 18px;
    }
  }
  .el-form-item__content {
    .el-input,
    .el-textarea {
      width: 380px;
    }
  }
  .el-radio {
    margin-right: 20px;
    &:last-child {
      margin-right: 0;
    }
  }
}
.goodsUrl {
  width: 1px;
  height: 1px;
  position: absolute;
  top: 0;
  opacity: 0;
}
</style>
